module.exports = __webpack_public_path__ + "img/logo.07975462.png";